import React from "react";
import {Link} from "react-router-dom";
import altadena from "../assets/altadena.svg";
import styled from "styled-components";
import {useCurrentUser} from "src/components/_shared/hooks/useCurrentUser";
import {usePage} from "src/components/_shared/hooks/usePage";
import useBannerBlurb from "./useBannerBlurb";
const SocialFireRebuildsBlurb = () => {
  const {isSignedIn} = useCurrentUser();
  const {columnCount} = usePage();
  const showBlurb = useBannerBlurb();
  if (isSignedIn || !showBlurb) {
    return null;
  }

  return (
    <div
      id="socal-fire-rebuilds-blurb"
      style={{
        position: "relative",
        display: columnCount <= 12 ? "flex" : "none",
        flexWrap: "wrap",
        justifyContent: "center",
        backgroundColor: "#000",
        color: "#FFF",
        alignItems: "center",
        textAlign: "center",
        gap: "12px",
        padding: "16px 32px",
      }}
    >
      <div
        style={{
          display: "flex",
          flexWrap: "wrap",
          alignItems: "center",
          justifyContent: "center",
          textAlign: "center",
          gap: "12px",
        }}
      >
        <img
          src={altadena}
          height={20}
          width={20}
          color={"red"}
          alt="Villa Logo"
        />
        <a
          href="/socal-fire-rebuilds"
          className="text-white"
          style={{fontSize: "14px"}}
        >
          Villa is building primary homes for those impacted by the SoCal fires.
        </a>
      </div>
      <a
        href="/socal-fire-rebuilds?request=open"
        className="text-white"
        style={{fontSize: "16px"}}
      >
        Request a free consultation
      </a>
    </div>
  );
};

const BannerLink = styled.a`
  font-size: 14px;
  color: #fff;
  background-color: #000;
  border-radius: 4px;
  padding: 8px 16px;
  border: 1px solid #fff;
  cursor: pointer;
  text-decoration: none;
  font-weight: 550;
  &:hover {
    text-decoration: none;
    background-color: #fff;
    color: #000;
  }
`;

export default SocialFireRebuildsBlurb;
